module.exports = __webpack_public_path__ + "static/media/cohesion_heatmap_3.47a713ef.png";